import { inject, Injectable } from '@angular/core';
import { FlyoutAccountSummaryHeader } from '@com-delta-idp/mnx-capability-flyout-ui';
import {
  HeaderFooterMachCoreContentService,
  UserSessionService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { take } from 'rxjs/operators';
import { FlyoutAccountSummaryHeaderAdapterService } from '../../adapters/account-summary-header/flyout-account-summary-header-adapter.service';
import { FlyoutFooterFacadeService } from '../footer/flyout-footer-facade.service';

@Injectable({
  providedIn: 'root'
})
export class FlyoutAccountSummaryHeaderFacadeService {
  adapter = inject(FlyoutAccountSummaryHeaderAdapterService);
  userSession = inject(UserSessionService);
  headerFooterContent = inject(HeaderFooterMachCoreContentService);
  footerFacade = inject(FlyoutFooterFacadeService);

  accountSummaryHeaderDetails$ =
    new BehaviorSubject<FlyoutAccountSummaryHeader>(
      {} as FlyoutAccountSummaryHeader
    );

  init(): void {
    if (this.accountSummaryHeaderDetails$.getValue().firstName) {
      return;
    } else {
      forkJoin([
        this.userSession.getUserSession().pipe(take(1)),
        this.headerFooterContent.getHeaderFooterMachCoreContent$().pipe(take(1))
      ]).subscribe(([dashboardResponse, content]) => {
        this.accountSummaryHeaderDetails$.next(
          this.adapter.getContent(dashboardResponse, content)
        );
        this.footerFacade.init(content);
      });
    }
  }
}
